import { ConfiguratorGroupDto } from '@/services/configurator';

/**
 * Use the explicit `isSent` flag (server stamps it when the buyer actually
 * signs/submits). NOT `isLocked` — that's also set true by an expired deadline,
 * so it would flag unsigned-but-locked groups as signed once the stopptid passes.
 * Exclude lockedByForceSelectionPreset — that's a pre-style-pick lock that
 * has nothing to do with the buyer having signed.
 *
 * In the showroom there is no buyer and no signing, so a group is never signed.
 */
export function isGroupSigned(group: ConfiguratorGroupDto, isShowroom = false): boolean {
    if (isShowroom) return false;
    return group.selectedOption != null && group.isSent && !group.lockedByForceSelectionPreset;
}
